<template>
  <div class="inpBox">
    <div class="detailsTitle">
      <h4>编辑货源</h4>
      <div @click="back"><i class="fa fa-reply"></i></div>
  </div>
   <el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
      <div class="addressBox noedit">
        <h4 class="title">
          <span><i class="fa fa-envelope iconFont" aria-hidden="true"></i>收发货信息</span>
        </h4>
        <div>
            <el-form-item  label="发货单位:" prop="deliverCompany">
            <el-input  placeholder="" class="disabled" maxlength="20" :readonly="true"  v-model="goodform.deliverCompany"></el-input>
          </el-form-item>
          <el-form-item    label="发货人:" prop="deliverPerson">
            <el-input  placeholder="" class="disabled" maxlength="10" :readonly="true"  v-model="goodform.deliverPerson"></el-input>
          </el-form-item>
          <el-form-item label="发货人电话:"  prop="deliverPhone">
            <el-input  placeholder="" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="goodform.deliverPhone"></el-input>
          </el-form-item>
          <el-form-item  label="发货地址:" prop="deliverAddress" class="diqu1">
            <el-input  placeholder="" class="disabled" maxlength="11" :readonly="true"  v-model="goodform.deliverAddress"></el-input>
          </el-form-item>

        </div>
        <div>
          <el-form-item label="收货单位:" prop="receivingCompany">
          <el-input  placeholder="" class="disabled" maxlength="20" :readonly="true"  v-model="goodform.receivingCompany"></el-input>
        </el-form-item>
        <el-form-item  label="收货人:" prop="receivingPerson">
          <el-input  placeholder="" class="disabled" maxlength="10" :readonly="true"  v-model="goodform.receivingPerson"></el-input>
        </el-form-item>
        <el-form-item label="收货人电话:" prop="receivingPhone">
          <el-input  placeholder="" class="disabled" maxlength="11" :readonly="true"  type="tel" v-model="goodform.receivingPhone"></el-input>
        </el-form-item>
          <el-form-item  label="收货地址:" prop="receivingAddress" class="diqu1">
          <el-input  placeholder="" class="disabled" maxlength="11" :readonly="true"  v-model="goodform.receivingAddress"></el-input>
        </el-form-item>

        </div>
      </div>
      <hr>
      <div class="addressBox">
         <h4 class="title">
          <span><i class="fa fa-cubes iconFont" aria-hidden="true"></i>货物信息</span>
        </h4>
        <div>
           <el-form-item label="货物名称:" prop="productName">
        <el-input  placeholder="" maxlength="20"   v-model="goodform.productName"></el-input>
      </el-form-item>
      <el-form-item label="货物类型:"  prop="productType">
        <el-select  v-model="goodform.productType"  value-key="productId"  placeholder="请选择">
          <el-option v-for="item in productTypes" :label="item.name" :value="item" :key="item.productId"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="货物长度:"  class="jiage" prop="productLong">
        <el-input  placeholder=""  v-number-input.float="3"  maxlength="8" v-model="goodform.productLong"></el-input><span class="danwei">米</span>
      </el-form-item>
       <el-form-item label="货物宽度:"  class="jiage" prop="productWide">
        <el-input  placeholder=""  v-number-input.float="3"  maxlength="8" v-model="goodform.productWide"></el-input><span class="danwei">米</span>
      </el-form-item>
       <el-form-item label="货物高度:"  class="jiage" prop="productHigh">
        <el-input  placeholder="" v-number-input.float="3"  maxlength="8"  v-model="goodform.productHigh"></el-input><span class="danwei">米</span>
      </el-form-item>
      <el-form-item label="货物件数:"  class="jiage" prop="productNum">
        <el-input  placeholder="" v-number-input.float="0" :readonly="true"   maxlength="10"   v-model="goodform.productNum"></el-input><span class="danwei">件</span>
      </el-form-item>
      <el-form-item label="货物总重:"  class="jiage" prop="allWeight">
        <el-input  placeholder="" v-number-input.float="3"  :readonly="true"   maxlength="8"  v-model="goodform.allWeight"></el-input><span class="danwei">吨</span>
      </el-form-item>
      <el-form-item label="" class="mar10">
        总体积:<span class="red">{{goodform.productVolume}}</span>立方米
      </el-form-item>
        </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-calculator iconFont" aria-hidden="true"></i>相关费用</span>
        </h4>
        <div>
        <el-form-item label="计价方式 :" prop="pricingMethod" class="jiage">
        <el-select  v-model="goodform.pricingMethod"  placeholder="请选择" >
          <el-option v-for="val in jjfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
          <!-- <el-option label="区域二" value="beijing"></el-option> -->
        </el-select>
      </el-form-item>

      <el-form-item label="单价:" class="jiage" prop="price" v-if="goodform.pricingMethod==null||goodform.pricingMethod==2?false:true">
    <el-input  placeholder=""  v-number-input.float="2"   maxlength="8" v-model="goodform.price"  ></el-input><span class="danwei">元</span>
  </el-form-item>
  <el-form-item label="包干价:" class="jiage" prop="price" v-if="goodform.pricingMethod==null||goodform.pricingMethod==1?false:true">
    <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="goodform.price" ></el-input><span class="danwei">元</span>
  </el-form-item>
        <el-form-item label="仓储费:" prop="storagePrice" class="jiage">
        <el-input  placeholder="" maxlength="8"  v-model="goodform.storagePrice"></el-input><span class="danwei">元</span>
      </el-form-item>
      <el-form-item label="支付方式 :" prop="paymentType" class="jiage">
        <el-select  v-model="goodform.paymentType"  placeholder="">
          <el-option v-for="val in jsfangshi" :label="val.name" :value="val.val" :key="val.val"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="" class="mar10">
        合计费用:<span class="red">{{goodform.allPrice}}</span>元
      </el-form-item>
      </div>
      </div>
      <hr>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>其他信息</span>
        </h4>
        <div>

      <el-form-item label="期望发货时间:" prop="hopeDeliverDate">
            <el-date-picker
              v-model="goodform.hopeDeliverDate"
              format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <el-form-item label="期望到货时间:" prop="hopeReceivingDate">
            <el-date-picker
              v-model="goodform.hopeReceivingDate"
              format="yyyy-MM-dd HH:mm:ss"
               value-format="timestamp"
              type="datetime"
                placeholder="选择日期时间"
                 :picker-options="pickerOptions"
            ></el-date-picker>
      </el-form-item>
      <div>
          <el-form-item label="备注:" class="remark" prop="remark" >
            <el-input  placeholder=""  maxlength="500" v-model="goodform.remark"></el-input>
          </el-form-item>
      </div>
      <div class="imgBox">
         <ul>
           <li v-for="(item,index)  in goodform.sBillFileList" @click="lookImg(index)" :key="item.id"><img width="100%" :src="item.fileKeyUrl" alt=""></li>
        </ul>

      <el-dialog  title="图片展示" :visible.sync="imgDialog" center>
        <img width="100%" :src="dialogImageUrl" alt="">
      </el-dialog>
      </div>

      </div>
      </div>
      <div class="addressBox">
        <h4 class="title">
          <span><i class="fa  fa-stack-overflow iconFont" aria-hidden="true"></i>货物明细</span>
          <el-button type="primary" size="mini" style="margin-left:10px" @click="addGood">添加货物</el-button>
        </h4>
        <div>
          <el-table :data="goodsList"  ref="table"    bordersize="mini"
       style="width: 100%" center>
        <el-table-column  type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click="editGood(scope.row,scope.$index)">编辑</el-button>
                  <el-button type="text" size="mini" @click="delGood(scope.row)">删除</el-button>
                </template>
        </el-table-column>
        <el-table-column property="cargoBarcode" width="200" label="捆包号"></el-table-column>
          <el-table-column property="productTypeName" width="100" label="货物类型"></el-table-column>

          <el-table-column property="productName"  width="140"  label="品名"></el-table-column>
          <el-table-column property="model" width="120" label="材质"></el-table-column>
          <el-table-column property="specification" width="140"  label="规格"></el-table-column>
           <el-table-column property="number" width="140"  label="件数"></el-table-column>
          <el-table-column property="weight" width="100" label="重量(吨)"></el-table-column>
          <el-table-column property="contractNumber" width="120" label="合同号"></el-table-column>
          <el-table-column property="agreementNumber" width="120" label="合约号"></el-table-column>
          <el-table-column property="cargoLocation" width="150" label="货位"></el-table-column>
      </el-table>
        </div>
      </div>
   </el-form>
<el-dialog  title="货物信息"  :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan"  :visible.sync="dialogVisible" width="860px" center>
         <el-form :inline="true" :rules="addRules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="inpBox">
               <el-form-item label="捆包号:" prop="cargoBarcode">
                <el-input  placeholder="" :readonly="true" class="disabled" maxlength="40"  v-model="addFrom.cargoBarcode" ></el-input>
              </el-form-item>
              <el-form-item label="货物类型:" class="jiage" prop="productType">
                <el-select  v-model="addFrom.productType"  value-key="productId"  placeholder="请选择">
                  <el-option v-for="item in productTypes" :label="item.name" :value="item" :key="item.productId"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="品名:" prop="productName">
                <el-input  placeholder=""  maxlength="20" v-model="addFrom.productName"></el-input>
              </el-form-item>
              <el-form-item label="材质:" prop="model">
                <el-input  placeholder=""  maxlength="20" v-model="addFrom.model"></el-input>
              </el-form-item>
              <el-form-item label="规格:" prop="specification">
                <el-input  placeholder=""  maxlength="20" v-model="addFrom.specification"></el-input>
              </el-form-item>
               <el-form-item label="货物件数:"  class="jiage" prop="number">
                <el-input  placeholder="" v-number-input.float="0"  maxlength="5"   v-model="addFrom.number"></el-input><span class="danwei">件</span>
              </el-form-item>
              <el-form-item label="货物总重:"  class="jiage" prop="weight">
                <el-input  placeholder="" v-number-input.float="3"   maxlength="8"  v-model="addFrom.weight"></el-input><span class="danwei">吨</span>
              </el-form-item>
              <el-form-item label="合同号:" prop="contractNumber">
                <el-input  placeholder=""  maxlength="20" v-model="addFrom.contractNumber"></el-input>
              </el-form-item>
              <el-form-item label="合约号:" prop="agreementNumber">
                <el-input  placeholder=""  maxlength="20" v-model="addFrom.agreementNumber"></el-input>
              </el-form-item>
              <el-form-item label="货位:" prop="cargoLocation">
                <el-input  placeholder=""  maxlength="20" v-model="addFrom.cargoLocation"></el-input>
              </el-form-item>

        </div>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="AddSaveFn(1)">下一条</el-button>
        <el-button type="primary" @click="AddSaveFn(2)">确 定</el-button>
        <el-button type="primary" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
   <div class="footerBtn">
      <el-button type="primary" class="bigBtn" @click="saveFn(1)">暂 存</el-button>
      <el-button type="primary" class="bigBtn" @click="saveFn(2)">提 交</el-button>
    </div>

  </div>
</template>

<script>
import { SBLdetail, dropDownList, SBPadd, SBPlist, SBPupdate, SBPdelete, sBillUpdate } from '@/api/soc-customer'
export default {
  data () {
    let id = this.$route.query.id
    return {
      id: id,
      dialogImageUrl: '',
      dialogVisible: false,
      imgDialog: false,
      goodsList: [],
      isAdd: false,
      freight: 0.00,
      productTypes: [
        { val: '', name: '全部' },
        { val: 1, name: '热卷' },
        { val: 2, name: '冷卷' },
        { val: 3, name: '中厚板' }
      ],
      jjfangshi: [
        { val: 1, name: '按吨' },
        { val: 2, name: '包干' }
      ],
      jsfangshi: [
        { val: 1, name: '电汇' },
        { val: 2, name: '现金' },
        { val: 3, name: '其他' }
      ],

      addFrom: {},
      rules: {
        storagePrice: [
          { pattern: /^[0-9]{1,8}([.][0-9]{1,2})?$/, message: '最大输入99999999.99' }
        ],

        pricingMethod: [
          { required: true, message: '请选择计价方式', trigger: 'blur' }
        ],
        price: [
          { required: true, message: '请输入单价或者包干价', trigger: 'blur' },
          { pattern: /^[0-9]{1,5}([.][0-9]{1,2})?$/, message: '最大输入99999.99' }
        ],
        productLong: [
          { pattern: /^[0-9]{1,4}([.][0-9]{1,3})?$/, message: '最大输入9999.999' }
        ],
        productHigh: [
          { pattern: /^[0-9]{1,4}([.][0-9]{1,3})?$/, message: '最大输入9999.999' }
        ],
        productWide: [
          { pattern: /^[0-9]{1,4}([.][0-9]{1,3})?$/, message: '最大输入9999.999' }
        ]
      },
      addRules: {
        productName: [
          { required: true, message: '请输入品名', trigger: 'blur' }
        ],
        number: [
          { required: true, message: '请输入货物件数', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入货源量', trigger: 'blur' },
          { pattern: /^[0-9]{1,4}([.][0-9]{1,3})?$/, message: '最大输入9999.999' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ]
      },
      goodform: {
        productVolume: 0,
        allPrice: 0,
        storagePrice: '',
        allWeight: '',
        price: '',
        paymentType: 1,
        pricingMethod: ''
      },
      index: 0,
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      }
    }
  },
  created () {
    SBLdetail({ id: this.id }).then(res => {
      this.goodform = res
      this.$set(this.goodform, 'productType', { name: res.productTypeName, productId: res.productTypeId })
      if (!res.paymentType) {
        this.$set(this.goodform, 'paymentType', 1)
      }
    })
    dropDownList().then(res => {
      this.productTypes = res
    })
    this.getList()
  },
  watch: {
    goodform: {
      handler (newName, oldName) {
        var allPrice = this.goodform.allWeight * this.goodform.price
        if (!Number.isNaN(allPrice)) {
          if (allPrice == 0) {
            if (this.goodform.pricingMethod == 1) {
              if (this.goodform.storagePrice == '' || this.goodform.storagePrice == 0) {
                this.$set(this.goodform, 'allPrice', 0)
              } else {
                this.$set(this.goodform, 'allPrice', this.goodform.storagePrice)
              }
            } else if (this.goodform.pricingMethod == 2) {
              if (this.goodform.storagePrice == '' || this.goodform.storagePrice == 0) {
                if (this.goodform.price != '') {
                  this.$set(this.goodform, 'allPrice', this.goodform.price)
                }
              } else {
                let n = this.$math.format(this.$math.add(this.$math.bignumber(this.goodform.price), this.$math.bignumber(this.goodform.storagePrice)))
                this.$set(this.goodform, 'allPrice', fomatFloat(n, 2))
              }
            }
          } else {
            var yunfei = 0
            if (this.goodform.pricingMethod == 1) {
              let weight = this.goodform.allWeight
              let price = this.goodform.price
              yunfei = this.$math.format(this.$math.multiply(this.$math.bignumber(weight), this.$math.bignumber(price)))
            } else if (this.goodform.pricingMethod == 2) {
              yunfei = this.goodform.price
            }
            if (this.goodform.storagePrice == '' || this.goodform.storagePrice == 0) {
              this.$set(this.goodform, 'allPrice', fomatFloat(yunfei, 2))
            } else {
              let n = this.$math.format(this.$math.add(this.$math.bignumber(yunfei), this.$math.bignumber(this.goodform.storagePrice)))
              this.$set(this.goodform, 'allPrice', fomatFloat(n, 2))
            }
          }
        }
        let productVolume = this.goodform.productLong * this.goodform.productWide * this.goodform.productHigh
        if (!isNaN(productVolume) && productVolume) {
          productVolume = this.goodform.productLong * this.goodform.productWide * this.goodform.productHigh
          this.$set(this.goodform, 'productVolume', fomatFloat(accMul(this.goodform.productLong, this.goodform.productWide, this.goodform.productHigh), 3))
        } else {
          this.$set(this.goodform, 'productVolume', 0)
        }
        function fomatFloat (num, n) {
          var f = parseFloat(num)
          if (isNaN(f)) {
            return false
          }
          f = Math.round(num * Math.pow(10, n)) / Math.pow(10, n) // n 幂
          var s = f.toString()
          var rs = s.indexOf('.')
          // 判定如果是整数，增加小数点再补0
          if (rs < 0) {
            rs = s.length
            s += '.'
          }
          while (s.length <= rs + n) {
            s += '0'
          }
          return s
        }
        function accMul (arg1, arg2, arg3) {
          if (arg1 && arg2 && arg3) {
            var m = 0; var s1 = arg1.toString(); var s2 = arg2.toString(); var s3 = arg3.toString()
            try {
              m += s1.split('.')[1].length
            } catch (e) {
            }
            try {
              m += s2.split('.')[1].length
            } catch (e) {
            }
            try {
              m += s3.split('.')[1].length
            } catch (e) {
            }
            return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) * Number(s3.replace('.', '')) / Math.pow(10, m)
          }
        }
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    saveFn (n) {
      this.goodform.customerStatus = n
      this.goodform.productTypeId = this.goodform.productType.productId
      this.goodform.productTypeName = this.goodform.productType.name

      if (n == 1) {
        this.$refs.goodform.validateField(['productLong', 'productHigh', 'productWide'], errMsg => {
          if (errMsg) {

          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            sBillUpdate(this.goodform).then(res => {
              loading.close()
              this.$router.push({ name: 'goodsManage' })
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      } else {
        this.$refs.goodform.validate((valid) => {
          if (valid) {
            if (this.goodsList.length < 1) {
              this.$alert('请至少添加一条货物', '系统提示')
            } else {
              const loading = this.$loading({
                lock: true,
                text: '正在处理...'
              })
              sBillUpdate(this.goodform).then(res => {
                loading.close()
                this.$router.push({ name: 'goodsManage' })
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            }
          }
        })
      }
    },
    // 删除货物
    delGood (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        SBPdelete({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 添加货物
    addGood () {
      this.addFrom = {}
      this.dialogVisible = true
      this.isAdd = true
    },
    // 编辑货物
    editGood (row, n) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$set(this.addFrom, 'productType', { name: row.productTypeName, productId: row.productTypeId })
      this.index = n
      this.isAdd = false
      this.dialogVisible = true
    },
    // 添加修改货物保存
    AddSaveFn (n) {
      this.$refs.addFrom.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.isAdd) {
            this.addFrom.billId = this.goodform.id
            this.addFrom.billNo = this.goodform.billNo
            this.addFrom.tenantId = this.goodform.tenantId
            this.addFrom.tenantName = this.goodform.tenantName
            this.addFrom.productTypeId = this.addFrom.productType.productId
            this.addFrom.productTypeName = this.addFrom.productType.name
            if (n == 1) {
              SBPadd(this.addFrom).then(res => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.getList()
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            } else {
              SBPadd(this.addFrom).then(res => {
                loading.close()
                this.$message({
                  message: '添加成功',
                  type: 'success'
                })
                this.getList()
                this.dialogVisible = false
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            }
          } else {
            this.addFrom.productTypeId = this.addFrom.productType.productId
            this.addFrom.productTypeName = this.addFrom.productType.name
            if (n == 1) {
              SBPupdate(this.addFrom).then(res => {
                loading.close()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.getList()
                this.index = this.index + 1
                if (this.index == this.goodsList.length) {
                  this.dialogVisible = false
                } else {
                  var row = this.goodsList[this.index]
                  this.addFrom = JSON.parse(JSON.stringify(row))
                  this.$set(this.addFrom, 'productType', { name: row.productTypeName, productId: row.productTypeId })
                }
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            } else {
              SBPupdate(this.addFrom).then(res => {
                loading.close()
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.getList()
                this.dialogVisible = false
              }).catch(error => {
                this.$message({
                  showClose: true,
                  message: error.message,
                  type: 'error',
                  onClose () {
                    loading.close()
                  }
                })
              })
            }
          }
        }
      })
    },
    // 获取货物列表
    getList (searchFrom) {
      SBPlist({ billId: this.id }).then(res => {
        this.goodsList = res
        this.goodform.productNum = this.goodsList.length
        var weight = 0
        res.forEach(item => {
          weight = (weight * 1000 + item.weight * 1000) / 1000
        })
        this.goodform.allWeight = weight
      })
    },
    // 查看图片
    lookImg (n) {
      this.imgDialog = true
      this.dialogImageUrl = this.goodform.sBillFileList[n].fileKeyUrl
    },
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }

  }
}
</script>

<style scoped lang='less'>

.imgBox{
  margin: 22px 10px;
  ul{
    display: flex;
    padding-left: 0;
    li{
         width: 160px;
    height: 160px;
    list-style: none;
    margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.noedit .disabled /deep/.el-input__inner{
  background: #fff;
  border:none;
  padding: 0;
}
.noedit /deep/.el-form-item{
margin-bottom: 0!important;
}
</style>
